import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@e2n/ui';
import {
  getWiederholungStringFromTerminWiederholungsIntervall,
  TerminWeekdayOccurrence,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';

interface RepetitionIntervallProps extends UpdateTermineFormProps {
  value: TerminWiederholungsIntervall;
  onChange: (value: TerminWiederholungsIntervall) => void;
}

export default function RepetitionInterval({
  value,
  onChange,
  form,
}: RepetitionIntervallProps) {
  return (
    <form.Subscribe selector={(state) => state.values.wochentagAuftreten}>
      {(selectedWeekdayOccurrence) => {
        const handleMonthOrYearInterval = () => {
          form.setFieldValue('wochentagAuswahl', []);
          if (!selectedWeekdayOccurrence) {
            form.setFieldValue(
              'wochentagAuftreten',
              TerminWeekdayOccurrence.FIXER_TAG,
            );
          }
        };

        const intervalHandlers: Record<
          TerminWiederholungsIntervall,
          () => void
        > = {
          [TerminWiederholungsIntervall.TAG]: () => {
            form.setFieldValue('wochentagAuftreten', undefined);
            form.setFieldValue('wochentagAuswahl', []);
          },
          [TerminWiederholungsIntervall.WOCHE]: () => {
            form.setFieldValue('wochentagAuftreten', undefined);
          },
          [TerminWiederholungsIntervall.MONAT]: () => {
            form.setFieldValue('wochentagAuswahl', []);
            handleMonthOrYearInterval();
          },
          [TerminWiederholungsIntervall.JAHR]: () => {
            form.setFieldValue('wochentagAuswahl', []);
            handleMonthOrYearInterval();
          },
        };

        function handleIntervalChange(
          selectedInterval: TerminWiederholungsIntervall,
        ) {
          if (!selectedInterval) {
            return;
          }
          onChange(selectedInterval);
          intervalHandlers[selectedInterval]();
        }

        return (
          <div className="pb-3 h-10">
            <Select value={value} onValueChange={handleIntervalChange}>
              <SelectTrigger className="border-neutrals-300 w-full">
                <div>
                  {getWiederholungStringFromTerminWiederholungsIntervall(value)}
                </div>
              </SelectTrigger>
              <SelectContent className="border-none overflow-visible">
                <SelectGroup>
                  {Object.values(TerminWiederholungsIntervall).map(
                    (enumValue) => (
                      <SelectItem key={enumValue} value={enumValue}>
                        {getWiederholungStringFromTerminWiederholungsIntervall(
                          enumValue,
                        )}
                      </SelectItem>
                    ),
                  )}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        );
      }}
    </form.Subscribe>
  );
}
